import {materialEstimateUnitStates} from "../MaterialEstimateUnitState";

export const RequestsPurchaseItemFilterData = [
    {
        "idFromColumnFilter": "articleNumber",
        "id": "articleNumber"
    },
    {
        "idFromColumnFilter": "name",
        "id": "name"
    },
    {
        "idFromColumnFilter": "unitId",
        "id": "unitId",
        "filterFn": (value, filterValue, filterEnum) => filterEnum[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "note",
        "id": "note"
    },
    {
        "idFromColumnFilter": "quantity",
        "id": "quantity"
    },
    {
        "idFromColumnFilter": "materialEstimateUnitState",
        "id": "materialEstimateUnitState",
        "filterFn": (value, filterValue) => materialEstimateUnitStates[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]